<template>
    <div>
        <div class="form-title">优惠券核销</div>
        <div class="fit-width">
            <div class="form-label">用户病历号:</div>
            <div class="form-input">
                <input v-model="form.usePerson"/>
                <div class="sao-button" @click="scan1">扫一扫</div>
            </div>
            <div class="form-label">优惠码:</div>
            <div class="form-input">
                <input v-model="form.discountCode"/>
                <div class="sao-button" @click="scan2">扫一扫</div>
            </div>
            <div class="form-button" @click="check()">核销</div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, MessageBox, Toast} from 'mint-ui';

    export default {
        name: "ticketCheck",
        data() {
            return {
                form: {
                    usePerson: "",
                    discountCode: ""
                }
            }
        },
        methods: {
            check: function () {
                var _this = this;
                MessageBox({
                    title: '提示',
                    message: '确认核销？',
                    confirmButtonText: "确定"
                }).then(() => {
                    Indicator.open('加载中...');
                    _this.$ajax.postFormUrl(_this,_this.$api.discountCharge2, {
                        discountCode: _this.form.discountCode,
                        gainPerson: _this.form.usePerson,
                        baseUserId: ""
                    }, res => {
                        Indicator.close();
                        Toast("核销成功");
                    }, (err) => {
                        Indicator.close();
                        Toast(err.rspDesc);
                    })
                }).catch(() => {
                    // this.chargeInfo = "请先绑定患者用户"
                });
            },
            wxJsSdkAuth: function (params) {
                wx.config(Object.assign(params, {
                    // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
                }));
            },
            getAppid: function (callback) {
                api.getFormUrl(this, "/yy/front/getWxAppid", null, (res) => {
                    Indicator.close();
                    this.appid = res.appId;
                    this.appidAgent = res.componetAppId;
                    callback(res.componetAppId, res.appId)
                }, (err) => {
                    Indicator.close();
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                });
            },
            scan1:function (){
                var _this = this;
                this.scanQrcode((text) => {
                    _this.form.usePerson = text;
                })
            },
            scan2:function (){
                var _this = this;
                this.scanQrcode((text) => {
                    _this.form.discountCode = text;
                })
            },
            scanQrcode:function(callback){
                wx.scanQRCode({
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode","barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: function (res) {
                        var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                        callback(result)
                    }
                });
            }
        },
        created: function () {
            var _this = this;

            _this.getAppid((appid, appid2) => {
                api.get(_this, "/wx/jsapiSignature?appId=" + appid2 + "&url=" + encodeURIComponent(location.href), null, (res) => {
                    // alert(JSON.stringify(res.data.data))
                    _this.wxJsSdkAuth(res.data.data);
                }, () => {
                    Toast("网络出错，请稍后再试");
                })
            });
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .form-title {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        line-height: 100px;
    }

    .form-label {
        color: #888;
        font-size: 15px;
        margin-top: 10px;
    }

    .form-input {
        margin-top: 10px;
        position: relative;
    }

    .form-input input {
        width: 100%;
        padding: 10px 20px;
        border: 1px solid #888;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .fit-width {
        width: 80%;
        display: block;
        margin: auto;
    }

    .form-button {
        padding: 10px 20px;
        text-align: center;
        box-sizing: border-box;
        background: #00c0ef;
        color: white;
        border-radius: 6px;
        margin-top: 20px;
        font-size: 16px;
    }

    .sao-button {
        right: 3px;
        top: 3px;
        position: absolute;
        padding: 8px 10px;
        text-align: center;
        box-sizing: border-box;
        background: #00c0ef;
        color: white;
        border-radius: 6px;
    }
</style>